import { z } from 'zod';
import { ImportTypeSchema } from '../inputTypeSchemas/ImportTypeSchema'

/////////////////////////////////////////
// CORE IMPORT DEFINITION SCHEMA
/////////////////////////////////////////

export const CoreImportDefinitionSchema = z.object({
  importType: ImportTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  name: z.string(),
  awsDataBrewProjectName: z.string(),
  specialInstructions: z.string(),
  availableToAgency: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type CoreImportDefinition = z.infer<typeof CoreImportDefinitionSchema>

export default CoreImportDefinitionSchema;
